import gsap from 'gsap'

function init(menu) {
	const menuItemsPrimary = menu.querySelectorAll('.page-menu-primary .nav-link')
	const menuItemsSecondary = menu.querySelectorAll('.page-menu-secondary .nav-link')

	const menuTl = gsap.timeline({
		paused: true,
	})

	menuTl.from(menuItemsPrimary, {
		opacity: 0,
		rotateX: -90,
		ease: 'power2.out',
		stagger: 0.05,
	})

	menuTl.from(menuItemsSecondary, {
		opacity: 0,
		y: -25,
		ease: 'power2.out',
	}, '-=0.25')

	menu.addEventListener('shown.bs.offcanvas', () => {
		menuTl.play(0)
	})

	menu.addEventListener('hidden.bs.offcanvas', () => {
		menuTl.restart().pause()
	})
}

export {
	init
}
